import Vue from "vue";
import vuex from "vuex";
Vue.use(vuex);
export default new vuex.Store({
  state: {
    bannerLoading: true, //banner组件加载中
    isLogin: false, //显示登录弹窗
    myFollow: 0,
    msg_status: 0, //是否有未读通知
    isBack: false,

  },
  mutations: {

    setBanner(state, type) {
      state.bannerLoading = type;
    },

    setisLogin(state, value) {

      if (value == 1) {
        state.isLogin = true;
      } else {
        state.isLogin = false;
      }

    },


    setMyFollow(state, value) {
      state.myFollow = value;
    },


    setMsg(state, value) {
      state.msg_status = value;
    },


    setBack(state, value) {
      state.isBack = value;
    }

  }
});



// WEBPACK FOOTER //
// ./src/store/index.js